import React from "react";
import EdelLogoCenter from "../../UI/EdelLogoCenter/EdelLogoCenter";
import "./Layout.scss";
import DeviceContext from "../../../components/Services/identifyDevice";

export interface StatusLayoutProps {
  edelLogoClass?: string;
  statusClassName?: string;
  children?: React.ReactNode
}

const StatusLayout: React.FC<StatusLayoutProps> = (props) => {
  const isDesktop = DeviceContext().isDesktop;

  return (
    <>
      <div
        className={
          props?.statusClassName !== undefined && props?.statusClassName
            ? props?.statusClassName
            : "statusLayout"
        }
      >
        <header>
          <EdelLogoCenter
            headerLogoClassName={
              isDesktop && props?.edelLogoClass ? props?.edelLogoClass : ""
            }
          />
        </header>
        <main>
          {props.children}
        </main>
      </div>
    </>
  );
};

export default StatusLayout;
